'use client';

import { useProfile } from './profile';
import { useStoreCredits } from './store-credits';

type UseProfileTabsDataType = {
  hasCinemarkCash: boolean;
  hasWatchlist: boolean;
  isLoading: boolean;
};

export const useProfileTabsData = (): UseProfileTabsDataType => {
  const { data: profile, isLoading: loadingProfile } = useProfile();
  const { data: storeCreditsResponse, isLoading: loadingStoreCredits } = useStoreCredits();

  return {
    hasCinemarkCash: !!storeCreditsResponse?.totalCash,
    hasWatchlist: !!profile?.hasWatchListItems,
    isLoading: loadingProfile || loadingStoreCredits,
  };
};
